<div *ngIf="errorSvc.getMessage()" class="bg-danger warning-ribbon container-fluid d-inline-block text-center w-100" [@errorRibbon]="display">
  <p class="d-inline-block text-white text-sizing">{{ errorSvc.getMessage() }}</p>
</div>
